const CHANNEL = "CHANNEL";

/** Прокси-страница, за которой закреплён канал. */
export function isChannelProxyPage(arenaProxyPage) {
  return Boolean(
    arenaProxyPage?.content?.type === CHANNEL &&
      arenaProxyPage?.content?.channel?.slug
  );
}

/**
 * Значение ProxyPageOverrideContext: SEO-поля и canonical прокси-страницы
 * вместо полей привязанного объекта.
 */
export function buildProxyPageOverride(arenaProxyPage, arena) {
  const {
    metadataTitle,
    metadataDescription,
    metadataKeywords,
    path,
    overrideTitle,
    overrideDescription,
  } = arenaProxyPage;

  return {
    title: metadataTitle || null,
    description: metadataDescription || null,
    keywords: metadataKeywords || null,
    canonicalUrl: `${arena.url}${path}`,
    displayTitle: overrideTitle || null,
    displayDescription: overrideDescription || null,
  };
}
